__turbopack_context__.v({
  "trixEditorContainer": "TrixEditor-module__ZEdYAq__trixEditorContainer",
});
